module.exports = __webpack_public_path__ + "static/media/lb-pwd.ccf30501.svg";